import Can from "../../utils/can";
import LoyaltySettings from "../systemsettings/loyalty";

const LoyaltyPage = () => {
  return (
    <div className="row">
      <Can permission={"view_loyalty_setting"}>
        <LoyaltySettings />
      </Can>
    </div>
  );
};

export default LoyaltyPage;
